// extracted by mini-css-extract-plugin
export default {"input":"Option_input__h1sXi"};